import { Loader } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import toastStyles from './toasts.module.scss';
const LoadingToast = () => {
  const [t] = useTranslation();
  return (
    <div className={`m-auto ${toastStyles['toast_container-loader-text']}`}>
      <div className="mb-2">{t('UPDATING')}</div>
      <Loader size="small" />
    </div>
  );
};

export default LoadingToast;
